// TUT-497 — as visões salvas das listas: listar (as do escritório e as minhas,
// de uma lista), salvar e excluir.
import { demoApi } from "../demo-data";
import type { ListaComVisoes, NovaVisaoDeLista, VisaoDeLista } from "../types";
import { request } from "./infra";

// Lido aqui, e não importado: o empacotador só dobra a constante no módulo
// que a escreve, e é isso que tira o demo do build de produção (TUT-448).
const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

export const apiDasVisoesDeLista = {
  visoesDaLista(lista: ListaComVisoes): Promise<{ items: VisaoDeLista[] }> {
    return useDemoApi
      ? demoApi.visoesDaLista(lista)
      : request<{ items: VisaoDeLista[] }>(`/list-views?list=${encodeURIComponent(lista)}`);
  },
  salvarVisaoDaLista(input: NovaVisaoDeLista): Promise<VisaoDeLista> {
    return useDemoApi
      ? demoApi.salvarVisaoDaLista(input)
      : request<VisaoDeLista>("/list-views", { method: "POST", body: JSON.stringify(input) });
  },
  excluirVisaoDaLista(id: string): Promise<void> {
    return useDemoApi
      ? demoApi.excluirVisaoDaLista(id)
      : request<void>(`/list-views/${encodeURIComponent(id)}`, { method: "DELETE" });
  },
};
